<style lang="scss" scoped>
/deep/ .comp-employee-insurance-export-dialog {
    margin-top: 6vh !important;
    max-width: 980px;
    width: 92%;

    .el-dialog__body {
        padding: 18px 22px 22px;
    }
}

.employee-insurance-export {
    .filter-panel {
        padding: 16px 16px 8px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        background: #fafafa;
    }

    .filter-item {
        width: 100%;
        margin-bottom: 8px;
    }

    .export-alert {
        margin: 14px 0;
    }

    .export-actions {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-gap: 16px;
    }

    .export-card {
        padding: 14px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        background: #fff;
    }

    .export-title {
        margin-bottom: 6px;
        color: #303133;
        font-size: 14px;
        font-weight: bold;
    }

    .export-desc {
        min-height: 36px;
        margin-bottom: 12px;
        color: #909399;
        font-size: 12px;
        line-height: 18px;
    }

    .export-button {
        width: 100%;
    }
}
</style>

<template>
    <el-dialog title="人员保险数据导出" custom-class="c-el-dialog comp-employee-insurance-export-dialog"
        :visible.sync="showDialog" :before-close="_close">
        <div class="employee-insurance-export">
            <div class="filter-panel">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-input class="filter-item" placeholder="姓名/身份证号/保单号" clearable v-model="form.keywords"
                            size="medium"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-date-picker class="filter-item" v-model="exportDateRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" size="medium"
                            value-format="yyyy-MM-dd" @change="changeExportDateRange">
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>

            <el-alert class="export-alert" type="warning" :closable="false"
                title="以下所有导出都基于当前筛选条件查询的数据导出!"></el-alert>

            <div class="export-actions">
                <div class="export-card" v-for="item in exportOptions" :key="item.type">
                    <div class="export-title">{{ item.title }}</div>
                    <div class="export-desc">{{ item.desc }}</div>
                    <el-button class="export-button" size="medium" :loading="exportingType === item.type"
                        :type="item.btnType"
                        :plain="item.plain"
                        :disabled="isExporting" @click="handleExport(item)">
                        {{ item.title }}
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { EmployeeInsurances } from "@/mixins/commonPageExport"
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "EmployeeInsuranceExportDialog",
    props: {
        query: {
            type: Object,
            default: () => ({})
        },
        maxExportCount: {
            type: Number,
            default: 20000
        }
    },
    data() {
        return {
            showDialog: false,
            form: {},
            exportDateRange: [],
            exportingType: "",
            exportOptions: [
                {
                    type: "all",
                    title: "按筛选条件全量导出",
                    desc: "不做去重，直接导出当前筛选条件命中的人员保险数据。",
                    btnType: "primary",
                    plain: false
                },
                {
                    type: "nameIdNumber",
                    title: "按姓名+身份证号去重导出",
                    desc: "按姓名、身份证号去重，相同人员保留保险结束时间最近的一条记录。",
                    btnType: "warning",
                    plain: false
                }
            ]
        }
    },
    computed: {
        isExporting() {
            return !!this.exportingType
        }
    },
    methods: {
        open() {
            this.form = this.clone(this.query)
            this.exportDateRange = []
            if (this.form.beginDate && this.form.endDate) {
                this.exportDateRange = [this.form.beginDate, this.form.endDate]
            }
            this.showDialog = true
        },
        _close() {
            if (this.isExporting) return false
            this.showDialog = false
        },
        clone(data) {
            return JSON.parse(JSON.stringify(data || {}))
        },
        normalizeValue(value) {
            if (value === null || value === undefined) return ""
            return String(value).trim()
        },
        changeExportDateRange(val) {
            if (val) {
                this.form.beginDate = val[0]
                this.form.endDate = val[1]
            } else {
                this.form.beginDate = ""
                this.form.endDate = ""
            }
        },
        buildSearchParams() {
            const searchs = this.clone(this.form)
            searchs.page = 1
            searchs.size = this.maxExportCount
            return searchs
        },
        async handleExport(option) {
            this.exportingType = option.type
            window.$common.fullLoading()
            try {
                const searchs = this.buildSearchParams()
                const res = await funEmployee.GetEmployeeInsuranceBindings(searchs)
                if (!res || !res.items || res.items.length <= 0) {
                    window.$common.closeFullLoading()
                    this.alert("没有需要导出的数据!")
                    return
                }
                if (res.totalCount > this.maxExportCount) {
                    window.$common.closeFullLoading()
                    this.warningMsg(`当前筛选条件命中${res.totalCount}条数据，不允许导出超过${this.maxExportCount}条数据，请缩小筛选条件!`)
                    return
                }

                let tableDatas = res.items.map((x, index) => this.formatExportItem(x, index))
                tableDatas = this.applyExportMode(tableDatas, option.type)
                const exportName = this.getExportName(searchs, option.title)
                EmployeeInsurances(exportName, tableDatas)
            } catch (error) {
                window.$common.closeFullLoading()
                console.log("export error", error)
                this.alert("导出失败，请重试!")
            } finally {
                this.exportingType = ""
            }
        },
        // 格式化导出数据（员工保单绑定：结束时间展示绑定结束日期，为空时后端已回落保单结束日期）
        formatExportItem(row, index) {
            const item = { ...row, __exportIndex: index }
            // 格式化日期
            item.insuranceStartDateDesc = moment(item.startDate).isValid() ? moment(item.startDate).format("YYYY-MM-DD") : ""
            item.insuranceEndDateDesc = moment(item.effectiveEndDate).isValid() ? moment(item.effectiveEndDate).format("YYYY-MM-DD") : ""
            // 去重比较与状态计算统一按展示用结束时间
            item.insuranceEndDate = item.effectiveEndDate || null
            // 员工状态（按关联档案实时判定，未建档显示未建档）
            item.employeeStatusDesc = item.employeeStatus === 1 ? (item.archiveLeaveDate ? "待离职" : "在职")
                : item.employeeStatus === 2 ? "离职" : "未建档"

            // 判断保险状态（与后端计算口径一致）
            if (item.policyNumber && moment(item.insuranceEndDate).isValid()) {
                const diffDay = moment(item.insuranceEndDate).diff(moment().format("YYYY-MM-DD"), "days")
                if (diffDay <= 0) {
                    item.insuranceState = 3
                    item.insuranceStateDesc = "已过期"
                } else if (diffDay <= 30) {
                    item.insuranceState = 2
                    item.insuranceStateDesc = "即将到期"
                } else {
                    item.insuranceState = 1
                    item.insuranceStateDesc = "正常"
                }
            } else {
                item.insuranceState = item.insuranceState || 0
                item.insuranceStateDesc = item.insuranceStateDesc || ""
            }
            return item
        },
        applyExportMode(data, type) {
            if (type === "all") return data
            if (type === "nameIdNumber") return this.deduplicateByNameIdNumber(data)
            return this.deduplicateByField(data, type)
        },
        // 获取时间戳用于比较
        getTimeValue(value) {
            const time = moment(value)
            return time.isValid() ? time.valueOf() : 0
        },
        // 按姓名+身份证号去重（保留最新的）
        deduplicateByNameIdNumber(data) {
            const grouped = {}
            const retained = []
            data.forEach(item => {
                const name = this.normalizeValue(item.name)
                const idNumber = this.normalizeValue(item.idNumber)
                // 如果姓名和身份证号都为空，保留原样
                if (!name && !idNumber) {
                    retained.push(item)
                    return
                }
                const key = `name:${name}|idNumber:${idNumber}`
                if (!grouped[key]) grouped[key] = []
                grouped[key].push(item)
            })

            Object.values(grouped).forEach(group => {
                // 保留保险结束时间最新的记录
                const best = group.reduce((best, item) => {
                    if (!best) return item
                    const currentTime = this.getTimeValue(item.insuranceEndDate)
                    const bestTime = this.getTimeValue(best.insuranceEndDate)
                    return currentTime > bestTime ? item : best
                }, null)
                retained.push(best)
            })
            return retained.sort((a, b) => a.__exportIndex - b.__exportIndex)
        },
        // 按字段去重
        deduplicateByField(data, field) {
            const grouped = {}
            const retained = []
            data.forEach(item => {
                const key = this.normalizeValue(item[field])
                if (!key) {
                    retained.push(item)
                    return
                }
                if (!grouped[key]) grouped[key] = []
                grouped[key].push(item)
            })

            Object.values(grouped).forEach(group => {
                // 保留保险结束时间最新的记录
                const best = group.reduce((best, item) => {
                    if (!best) return item
                    const currentTime = this.getTimeValue(item.insuranceEndDate)
                    const bestTime = this.getTimeValue(best.insuranceEndDate)
                    return currentTime > bestTime ? item : best
                }, null)
                retained.push(best)
            })
            return retained.sort((a, b) => a.__exportIndex - b.__exportIndex)
        },
        getExportName(searchs, title) {
            return `人员保险信息表-${title}.xlsx`
        }
    }
}
</script>
